/** When true, persist `addata_uuid` in localStorage so a second tab shares the same player id (resume same seat). */
export function resumeCrossTabPlayerUuid(): boolean {
  return process.env.REACT_APP_RESUME_CROSS_TAB_PLAYER_UUID === "true";
}

export function getStoredPlayerUuid(): string {
  if (typeof sessionStorage === "undefined") return "";
  if (resumeCrossTabPlayerUuid()) {
    return localStorage.getItem("addata_uuid") ?? sessionStorage.getItem("addata_uuid") ?? "";
  }
  return sessionStorage.getItem("addata_uuid") ?? "";
}

export function setStoredPlayerUuid(uuid: string): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem("addata_uuid", uuid);
  if (resumeCrossTabPlayerUuid()) {
    localStorage.setItem("addata_uuid", uuid);
  }
}

export function clearStoredPlayerUuid(): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem("addata_uuid");
  localStorage.removeItem("addata_uuid");
}
